import { fetchWithFirebaseAuth } from '../utils/sbsApiClient';

const BASE = (process.env.REACT_APP_SBS_TOOLS_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'https://us-central1-selenne-business-suite.cloudfunctions.net/sbsToolsApi' : '')).replace(/\/$/, '');

async function request(path, body = {}, signal) {
  const response = await fetchWithFirebaseAuth(`${BASE}/api/client-portal/v1/${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal,
  });
  const result = await response.json();
  if (!response.ok) {
    const error = new Error(result.error || 'Client portal access could not be loaded. Try again.');
    error.code = result.code;
    throw error;
  }
  return result;
}
export const loadClientConnections = signal => request('connections', {}, signal);
export const loadClientProjects = (connectionId, projectId, signal) => request('projects', { connectionId, ...(projectId ? { projectId } : {}) }, signal);
export const listClientPortalAccess = (companyId, signal) => request('access/list', { companyId }, signal);
export const grantClientPortalAccess = input => request('access/grant', input);
export const revokeClientPortalAccess = input => request('access/revoke', input);
